import { createSelector } from '@reduxjs/toolkit';
import { ILinkedPromo } from 'shared/types/purchaseTerm/purchaseTermsV2';

import { selectExtraPrices, selectFullPaymentTerm } from './purchaseTermsV2';

const EMPTY_PROMOS: ILinkedPromo[] = [];

export const selectLinkedPromos = createSelector(
  [selectFullPaymentTerm, selectExtraPrices],
  (fullPaymentTerm, extraPrices): ILinkedPromo[] => {
    if (!fullPaymentTerm || !extraPrices) {
      return EMPTY_PROMOS;
    }

    const { linkedPromos } = extraPrices;
    if (!fullPaymentTerm.dialog.linkedPromos || fullPaymentTerm.dialog.linkedPromos.promoIds.length === 0) {
      return EMPTY_PROMOS;
    }

    return fullPaymentTerm.dialog.linkedPromos.promoIds
      .map(id => linkedPromos.find(promo => promo.id === id))
      .filter(Boolean) as ILinkedPromo[];
  },
);
